import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sports-calendar',
  templateUrl: './sports-calendar.component.html',
  styleUrls: ['./sports-calendar.component.scss']
})
export class SportsCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
